'use client';

import { useEffect, useState, type RefObject } from 'react';

// One-shot entrance: resolves true the first time the element scrolls into view
// (prototype: IntersectionObserver, threshold 0, 18% bottom root margin).
export const useRevealOnce = (
  ref: RefObject<HTMLElement | null>,
  enabled = true,
): boolean => {
  const [revealed, setRevealed] = useState(!enabled);

  useEffect(() => {
    if (!enabled || revealed) return;
    const node = ref.current;
    if (!node) return;
    if (typeof IntersectionObserver === 'undefined') {
      setRevealed(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setRevealed(true);
          io.disconnect();
        }
      },
      { threshold: 0, rootMargin: '0px 0px 18% 0px' },
    );
    io.observe(node);
    return () => io.disconnect();
  }, [ref, enabled, revealed]);

  return revealed;
};
